module.exports = __webpack_public_path__ + "img/csss_la_montagne.ae2703c9.png";